<template>
  <v-card height="100%" :loading="storageValidation.loading" flat color="bg1">
    <v-list-item two-line :class="$vuetify.theme.isDark ? 'bg2' : 'white'">
      <v-list-item-content>
        <v-list-item-title class="title">Storage Settings</v-list-item-title>
        <v-list-item-subtitle class="subtitle-1">Customize your application storage settings</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-divider></v-divider>
    <v-sheet outlined class="pa-4 rounded-lg  ma-5 ml-8">
 <v-form v-model="valid">
      <v-sheet
      
        color="transparent"
        tile
        class="overflow-hidden pa-4 d-flex flex-column"
        style="gap: 1.5rem">
        
      <v-alert text v-if="!storage.hasCustomStorage" color="blue" >
          <v-icon small color="blue">mdi-information</v-icon>  Your data and your company’s data are securely stored in our reliable AVA Cloud Storage. However, you also have the option to use a custom storage solution — we support both Azure Blob Storage and any AWS-compatible storage provider.
            </v-alert>
              <v-checkbox label=" Enable Custom Storage" v-model="storage.hasCustomStorage" ></v-checkbox>
              <div v-if="storage.hasCustomStorage" class="storage-items-wrapper" >
                <v-label class="black--text mb-2 d-block">Provider</v-label>
              <v-select  v-model="storage.providerName" :items="cloudProviders" attach="#">
                 <template v-slot:selection="{item}">
               <div class="pa-2 d-flex justify-center align-center" style="height: 45px;">
                 <img width="32px" height="32px" :src="item.imageUrl"  class="mr-1"> <span>{{ item.text }}</span>
               </div>
                </template>
                <template v-slot:item="{item}">
                <img width="32px" :src="item.imageUrl" class="mr-1"  > <span>{{ item.text }}</span>
                </template>
              </v-select>
            <v-label v-if="storage.providerName=='azure'" class="black--text mb-2 d-block">Connection String</v-label>
            <v-text-field
            v-if="storage.providerName=='azure'"
              dense
              outlined
              :background-color="$vuetify.theme.isDark ? 'bg2' : 'white'"
              v-model="storage.connectionString"
              :rules="[formRules.required]"
              placeholder="Connection string"></v-text-field>
              <v-label v-if="storage.providerName=='aws'" class="black--text mb-2 d-block">Server Url</v-label>
            <v-text-field
            v-if="storage.providerName=='aws'"
              dense
              outlined
              :background-color="$vuetify.theme.isDark ? 'bg2' : 'white'"
              v-model="storage.serverUrl"
              placeholder="Server Url for ex: http://127.0.0.1:9000/"></v-text-field>

              <v-label v-if="storage.providerName=='aws'" class="black--text mb-2 d-block">Region</v-label>
            <v-text-field
            v-if="storage.providerName=='aws'"
              dense
              outlined
              :background-color="$vuetify.theme.isDark ? 'bg2' : 'white'"
              v-model="storage.awsRegion"
              placeholder="Region for Ex: us-east-1"></v-text-field>

              <v-label v-if="storage.providerName=='aws'" class="black--text mb-2 d-block">Key</v-label>
            <v-text-field
            v-if="storage.providerName=='aws'"
              dense
              outlined
              :background-color="$vuetify.theme.isDark ? 'bg2' : 'white'"
              v-model="storage.key"
              placeholder="Account Key"></v-text-field>
            <v-label v-if="storage.providerName=='aws'" class="black--text mb-2 d-block">Secret</v-label>
            <v-text-field
            v-if="storage.providerName=='aws'"
              dense
              outlined
              :background-color="$vuetify.theme.isDark ? 'bg2' : 'white'"
              v-model="storage.secret"
              :rules="[formRules.required]"
              placeholder="Account Secret"></v-text-field>
              <v-row>
                <v-col class="d-flex justify-space-between">
                  <v-btn :loading="storageValidation.loading" @click="validateConnection" color="primary">
                    <v-icon>mdi-check-circle-outline</v-icon> Validate Connection
                  </v-btn>
                  <v-alert   dense text color="success" v-if="storageValidation.success" > Storage Connected successfully!</v-alert>
                  <v-alert dense text color="error" v-if="storageValidation.errorMessage" >{{ storageValidation.errorMessage }}</v-alert>
                  
                </v-col>
              </v-row>
              </div>

        <!-- Save Button -->
        <div class="d-flex justify-end">
          <v-btn
            :disabled="!valid || !hasChanges"
            large
            text
            color="primary"
            :loading="storageValidation.loading"
            @click="saveStorageInfo">
            Save
          </v-btn>
        </div>
      </v-sheet>
    </v-form>
    </v-sheet>
   
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex';
  import permissions from '@Share/config/permissions';
  import { $has } from '@/utils';
  import formRules from '@Share/config/form-rules';
import companyService from '@/features/Company/service/company-management.service';
  import { log, warn, error } from '@/utils/debugLogger';
  export default {
    name: 'StorageSettings',
    data() {
      return {
        valid:false,
        storage:{},
        formRules,
              permissions,
        storageValidation:{
            loading:false,
             success:false,
             errorMessage:null
        },
        cloudProviders:[
          {
            text:'Azure',value:'azure',imageUrl:'/img/icons8-azure-storage-blob-32.svg'
            
          },{
            text:'AWS S3 Compatible storage',value:'aws',imageUrl:'/img/aws-s3.png'
          }
        ],
  
       
      };
    },
    computed: {
      ...mapGetters('ACCOUNT', {
        user: 'GET_USER',
      }),
      userPreferences() {
        return this.user?.userPreferences || {};
      },
      hasChanges() {
        return JSON.stringify(this.storage) !== JSON.stringify(this.originalStorage);
      },
    
    },
    watch: {
      
      },
      
    methods: {
      $has,
      resetStorageValidation() {
        this.storageValidation.loading = false;
        this.storageValidation.success = false;
        this.storageValidation.errorMessage = null;
      },
      validateConnection(){
        this.resetStorageValidation();
          this.storageValidation.loading=true;
             companyService.validateStorage(this.user.companyId,this.storage).then((res)=>{
            if(res.data.succeeded){
              this.storageValidation.success=true;
            }else{
              this.storageValidation.success=false;
               this.storageValidation.errorMessage=res.data.errorMessage||'Unknown error establishing connection with the storage!';
            }
        }).catch(error=>{
          log("error",error);
        }).finally(()=>{
           this.storageValidation.loading=false;
        })
         
      },
      saveStorageInfo(){
        companyService.validateStorage(this.user.companyId,this.storage).then((res)=>{
            if(res.data.succeeded){
               companyService.updateStorage(this.user.companyId,this.storage).then(()=>{
                this.$dialog.notify.success('Storage settings updated successfully.', {
                    position: 'top-right',
                    timeout: 2000,
                  });
       }).catch(error=>{
        log(error);
        this.$dialog.notify.error('Failed to update storage information');
       }).finally(()=>{

       });
            }
        })
       
      }
    },
    mounted() {
       companyService.getStorage(this.user.companyId).then(res=>{
        this.storage=res.data;
        this.originalStorage=structuredClone(this.storage);
       }).catch(error=>{
        log(error);
        this.$dialog.notify.error('Failed to get storage information');
       }).finally(()=>{

       });
    }
  };
</script>

<style scoped>
  .v-radio {
    margin-bottom: 8px;
  }
</style> 